import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { corporates, enableCorporate, disableCorporate, deleteCorporate } from "../../../api/corporateApi"
import { push } from "connected-react-router";

export default function* corporateSaga() {
  yield all([
    fork(watchFetchCorporatesRequest),
    fork(watchEnableCorporateRequest),
    fork(watchDisableCorporateRequest),
    fork(watchDeleteCorporateRequest),
  ]);
}

function* watchFetchCorporatesRequest() {
  yield takeLatest(
    actions.FETCH_CORPORATES_REQUEST,
    fetchCorporatesRequest
  )
}

function* fetchCorporatesRequest() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(corporates)
    yield put({ type: actions.FETCH_CORPORATES_SUCCESS, corporates: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_CORPORATES_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchEnableCorporateRequest() {
  yield takeLatest(
    actions.ENABLE_CORPORATE_REQUEST,
    enableCorporateRequest
  )
}

function* enableCorporateRequest(corporateData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(enableCorporate, corporateData.value.bank,corporateData.value)
    yield put({ type: actions.ENABLE_CORPORATE_SUCCESS, corporates: data })
    yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.ENABLE_CORPORATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchDisableCorporateRequest() {
  yield takeLatest(
    actions.DISABLE_CORPORATE_REQUEST,
    disableCorporateRequest
  )
}

function* disableCorporateRequest(corporateData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(disableCorporate,corporateData.value.bank, corporateData.value)
    yield put({ type: actions.DISABLE_CORPORATE_SUCCESS, corporates: data })
    yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.DISABLE_CORPORATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchDeleteCorporateRequest() {
  yield takeLatest(
    actions.DELETE_CORPORATE_REQUEST,
    deleteCorporateRequest
  )
}

function* deleteCorporateRequest(corporate) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(deleteCorporate, corporate.value.bank,corporate.value)
    yield put({ type: actions.DELETE_CORPORATE_SUCCESS, corporates: data })
    yield put(push(`/corporate`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.DELETE_CORPORATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }

  }
}